<div class="breadcrumb-area">
	<h1>Productos</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Administración de productos<a (click)="createProduct()" *ngIf="!creating"><i
					class="a-hover fa fa-plus"></i></a></h3>
	</div>
	<div class="card-body">
		<p class="text-muted">Un producto se encuentra activo si el icono <i class="fa fa-power-off"></i> se encuentra
			en color <span style="font-weight: 900;color: green;">verde</span>. Activa o desactiva el producto dando
			click sobre el icono antes mencionado.</p>
		<div class="row mb-3">
			<div class="col-md-6 mb-2">
				<div class="input-group input-group-sm">
					<label for="filterWord" class="input-group-text">Filtra</label>
					<input
						type="text"
						(input)="filter()"
						[(ngModel)]="filterWord"
						name="filterWord"
						placeholder="Ingresa el código o nombre del producto"
						id="filterWord"
						class="form-control">
				</div>
			</div>

			<div class="col-md-3 mb-2">
				<div class="input-group input-group-sm">
					<label for="filterFamily" class="input-group-text">Familia</label>
					<select
						id="filterFamily"
						class="form-select"
						[(ngModel)]="filterFamily"
						(change)="filter()">

						<option value="all">Todos</option>
						<option value="without">Sin familia</option>
						<option value="with">Con familia</option>

					</select>
				</div>
			</div>

			<div class="col-md-3 mb-2">
				<div class="input-group input-group-sm">
					<label for="filterXML" class="input-group-text">Código XML</label>
					<select
						id="filterXML"
						class="form-select"
						[(ngModel)]="filterXML"
						(change)="filter()">

						<option value="all">Todos</option>
						<option value="with">Con XML</option>
						<option value="without">Sin XML</option>

					</select>
				</div>
			</div>

		</div>
		
		<div class="row">
			<div class="col-sm">
				<div class="table table-responsive" *ngIf="pagination.total.length > 0">
					<table class="table">
						<caption *ngIf="filterWord">Se muestran los resultados para {{filterWord}}</caption>
						<thead>
							<tr class="tr-middle">
								<th class="ta">
									Estado
								</th>
								<th class="ta">
									Código
								</th>
								<th class="ta">
									Código de Barras
								</th>
								<th>
									Nombre
								</th>
								<th class="ta">
									Tipo
								</th>
								<th class="ta">
									Puede ser
									<br>
									<span class="can-be-title">
										<i class="fa-solid fa-cart-shopping text-warning"></i> Comprado
									</span>
									<span class="can-be-title">
										<i class="fa-solid fa-money-bill text-success"></i> Vendido
									</span>
								</th>
								<th class="ta">
									Familia
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let product of pagination.filter">
								<tr class="tr-middle">
									<td class="ta">
										<i *ngIf="!changing[product.id]" (click)="activeOrInactive(product)"
											class="status-category fa fa-power-off"
											[class.active-category]="product.active"></i>
										<span *ngIf="changing[product.id]" class="spinner-border spinner-border-sm"
											aria-hidden="true"></span>
									</td>
									<td class="ta">
										{{product.code}}
									</td>
									<td class="ta">
										<ng-container *ngIf="product.barCode">
											<span *ngIf="!seeing[product.id]">{{product.barCode}}</span>
											<span *ngIf="seeing[product.id]" class="barCode">{{product.barCode}}</span>
											<span (click)="seeing[product.id] = !seeing[product.id]"
												class="clickeable text-info"><i
													[ngClass]="seeing[product.id]?'fa fa-eye-slash':'fa fa-eye'"></i></span>
										</ng-container>
										<ng-container *ngIf="!product.barCode">
											<div class="superposition-parent with-hover" tooltip="No cuenta con código de barras">
												<i class="fa fa-barcode"></i>
												<i class="fa fa-question superposition-icon"></i>
											</div>
										</ng-container>
									</td>
									<td class="limit-td">
										{{product.name}}
									</td>
									<td class="ta">
										{{product.type=='b'?'Bien':'Servicio'}}
									</td>
									<td class="ta">
										<div class="can-be">
											<i *ngIf="product.bought" tooltip="Comprado"
												class="fa-solid fa-cart-shopping text-warning with-hover"></i>
											<i *ngIf="product.sold" tooltip="Vendido"
												class="fa-solid fa-money-bill text-success with-hover"></i>
										</div>
									</td>
									<td class="ta">
										<ng-container *ngIf="product.family">
											{{product.family}}
										</ng-container>
										<ng-container *ngIf="!product.family">
											<span class="opacity-30">
												--
											</span>
										</ng-container>
									</td>
									<td class="ta">
										<span class="a-hover" (click)="edit(product)"><i class="fa fa-edit"></i></span>
										<span class="a-hover text-warning" tooltip="Agregar a favoritos" (click)="openFavorite(product)">
											<i class="fa fa-star"></i>
										</span>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<span *ngIf="pagination.total.length == 0">
					<i class="fa fa-circle-info"></i>
					{{
						products.length === 0
						? 'Aún no se han ingresado productos'
						: 'No se encontraron productos con los filtros seleccionados'
					}}
				</span>
			</div>
			<app-pagination-custom [elements]="pagination"></app-pagination-custom>
		</div>
	</div>
</div>
<app-modal-create-product *ngIf="creating" [productId]="productIdEdited" [exempt]="exempt" [newProduct]="waitingFor"
	(close)="closeCreate($event)"></app-modal-create-product>
<app-modal-create-product-favorite
    *ngIf="favoriteProduct"
    [product]="favoriteProduct"
    (close)="closeFavorite()">
</app-modal-create-product-favorite>